(function() {

  function accordionInstagramParticipants() {
    $('.feedback__toggle-btn').click(function() {
      $(this).toggleClass('is-active');
      $('.feedback__list').slideToggle(350);
    })
  }


  const isRecruitmentPage = $('.recruitment').length;
  if(isRecruitmentPage) {
    accordionInstagramParticipants();
  }
})();